/**
 * @generated SignedSource<<b662527688925200d4cee2d75461234b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FeatureId = "getAnswers" | "potentialAnalysisV2" | "test";
export type lessonInsightsActiveFeatureTogglesQuery$variables = {};
export type lessonInsightsActiveFeatureTogglesQuery$data = {
  readonly FeatureToggle: {
    readonly ActiveFeatureToggleIds: ReadonlyArray<FeatureId>;
  };
};
export type lessonInsightsActiveFeatureTogglesQuery = {
  response: lessonInsightsActiveFeatureTogglesQuery$data;
  variables: lessonInsightsActiveFeatureTogglesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FeatureToggleQueries",
    "kind": "LinkedField",
    "name": "FeatureToggle",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ActiveFeatureToggleIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "lessonInsightsActiveFeatureTogglesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "lessonInsightsActiveFeatureTogglesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "ae17721d004a3a8e60fe626bfdbc345b",
    "id": null,
    "metadata": {},
    "name": "lessonInsightsActiveFeatureTogglesQuery",
    "operationKind": "query",
    "text": "query lessonInsightsActiveFeatureTogglesQuery {\n  FeatureToggle {\n    ActiveFeatureToggleIds\n  }\n}\n"
  }
};
})();

(node as any).hash = "d8969b9dd4cdc4591d0e2e92fb58352c";

export default node;
